import { render } from "./RichMenuConditionSetting.vue?vue&type=template&id=619a72f3&scoped=true"
import script from "./RichMenuConditionSetting.vue?vue&type=script&lang=ts"
export * from "./RichMenuConditionSetting.vue?vue&type=script&lang=ts"

import "./RichMenuConditionSetting.vue?vue&type=style&index=0&id=619a72f3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-619a72f3"

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTabs,QTab,QTabPanels,QTabPanel,QBtn,QTable,QTr,QTh,QTd});
